import React, { ImgHTMLAttributes } from 'react';
import { RouteComponentProps, Link } from 'react-router';
import C from '@ordermentum/ui-constants';

import { connect } from 'react-redux';
import { LoginBase } from './LoginBase';
import { SignInForm } from './Forms/LoginForm';
import { RouteParams } from './Forms/index.types';

export function Logo(props: ImgHTMLAttributes<HTMLImageElement>) {
  return <img className="w-64 mobile:w-32" {...props} />;
}

export const Header = () => (
  <Link to="/">
    <Logo src={`${C.IMAGE_URL}/logo-ordermentum-full.svg`} />
  </Link>
);

export const DefaultLoginComponent = (
  props: RouteComponentProps<RouteParams, {}>
) => (
  <LoginBase type="default" header={<Header />} {...props}>
    <SignInForm
      {...props}
      destination={props.location.query.registrationSuccessDestination}
    />
  </LoginBase>
);

export const DefaultLogin = connect()(DefaultLoginComponent);
